import axios from "axios";
import config from "../../constants/config";

const url1 = config.API_URL + '/admin/generateotp';
const url2 = config.API_URL + '/admin/transfer';


export const generateOtp = async (token) => {
    console.log('called generateOtp Method');
    return await axios.post(url1,{}, {
      headers: {
        Authorization: token, // Correct placement of Authorization header
        'Content-Type': 'application/json', // Ensure content type is set to JSON
      },
    });
  };


  export const createTransaction = async (token,payload) => {
    console.log('called createTransaction Method');
    return await axios.post(url2,
        {
         fromUserId: payload.fromUserId,
         toUserId: payload.toUserId,
         amount: payload.amount,
         otp: payload.otp,
         currencyType: payload.currencyType, //KARATS OR COINS
         description: payload.description,
    }, {
      headers: {
        Authorization: token, // Correct placement of Authorization header
        'Content-Type': 'application/json', // Ensure content type is set to JSON
      },
    });
  };
